/* @flow */

export const APPLICATION_ID = {
  FranceChannel: 'francechannel',
  Gaumont: 'gaumont',
  GaumontVIP: 'gaumontvip',
  MyVideofutur: 'myvideofutur',
  Post: 'posttvgo',
  Premiere: 'premiere',
  Vialis: 'vialis',
  Viva: 'viva',
  WiBox: 'wibox',
  ZeopTV: 'zeoptv',
};
